import { toast } from "react-toastify";
import { logout } from "../http/auth";
import { useAuthStore } from "../store/authStore";
import { useMutation } from "@tanstack/react-query";

const useLogout = () => {
  const { logout: logoutFromStore, user } = useAuthStore();
  const mutation = useMutation({
    mutationKey: ["logout"],
    mutationFn: async () => {
      return logout();
    },
    onSuccess: () => {
      logoutFromStore();
    },
    onError: (error) => {
      toast.error("Error while logout", { autoClose: 5000 });
    },
  });
  const handleLogout = () => {
    mutation.mutate();
  };
  return { handleLogout, user };
};
export default useLogout;
